import { AllEvents } from '@news-mono/web-common'
import React from 'react'
import { FootyLivesHerePromoCard } from './Promotions/FootyLivesHere'
import { RetireReadyPromoCard } from './Promotions/RetireReady'
import { SportsMasterclassPromoCard } from './Promotions/SportsMasterclass'
import { SummerOfCricketPromoCard } from './Promotions/SummerOfCricket'
import { TheGamePromoCard } from './Promotions/TheGame'
import { UpLatePromoCard } from './Promotions/UpLate'

export type Promotion =
    | 'footy-lives-here'
    | 'the-game'
    | 'summer-of-cricket'
    | 'sports-masterclass'
    | 'retire-ready'
    | 'up-late'

export type PromoCardProps = {
    promoType: Promotion
    onEvent: (event: AllEvents) => void
}

export const PromoCard = ({ promoType, onEvent }: PromoCardProps) => {
    switch (promoType) {
        case 'the-game': {
            return <TheGamePromoCard />
        }
        case 'footy-lives-here': {
            return <FootyLivesHerePromoCard onEvent={onEvent} />
        }
        case 'summer-of-cricket': {
            return <SummerOfCricketPromoCard />
        }
        case 'retire-ready': {
            return <RetireReadyPromoCard />
        }
        case 'sports-masterclass': {
            return <SportsMasterclassPromoCard />
        }
        case 'up-late': {
            return <UpLatePromoCard />
        }
        default: {
            return null
        }
    }
}
